(function() {
    'use strict';
    Odigeo.UIElements.enhanceTooltip = function(tooltipDiv) {
        var $el;
        var showTooltip;
        var hideTooltip;
        $el = (tooltipDiv instanceof $) ? tooltipDiv : $(tooltipDiv);

        // exit if there is no tooltipDiv
        if ($el.length === 0) {
            return false;
        }

        if ($el.attr('data-skip-enhance') === 'true') {
            return;
        }
        $el.attr({'data-skip-enhance': true});

        showTooltip = function() {
            if ($el.find('.tooltips-close').length !== 0) {
                $el.find('.tooltips-close').on(Odigeo.Events.tap, hideTooltip);
            }
            $el.removeClass('hidden');
        };

        hideTooltip = function() {
            if ($el.find('.tooltips-close').length !== 0) {
                $el.find('.tooltips-close').off(Odigeo.Events.tap);
            }
            $el.off(Odigeo.Events.touchend);
            $el.addClass('hidden');
        };

        $el.addClass('hidden');

        $el.on('showTooltip', showTooltip);
        $el.on('hideTooltip', hideTooltip);

        return {
            show: showTooltip,
            hide: hideTooltip,
        };
    };
}());
